import React from 'react';
import { observer } from 'mobx-react';
import { TextInput } from '@mantine/core';
import { UserStore } from '@seedlang/stores';
import TypeAhead from 'components/type_ahead';
import { isEmpty } from 'lodash';

@observer
class UserSearch extends React.Component {

  static defaultProps = {
    searchByField: 'email',
    placeholder: 'Enter User Email',
  };

  componentDidMount() {
    UserStore.setSort(this.props.searchByField);
    UserStore.setQueryStrings({simple: true});
  }

  componentWillUnmount() {
    this.onClear();
  }
  onKeyUp = (value) => {
    value = value.trim();
    if (isEmpty(value)) {
      this.onClear();
    } else {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        UserStore.getIndex({queryStrings: {full_text_search: true, email: value}});
      }, 500);
    }
  }
  onSelect = (obj) => {
    this.props.onSubmit(obj);
  }
  onClear = () => {
    UserStore.clearIndexData();
    UserStore.clearFilter();
  }

  render() {
    return (
      <div className='user-search' style={{margin: this.props.margin}}>
        <TypeAhead
          onKeyUp={this.onKeyUp}
          onSelect={this.onSelect}
          onClear={this.onClear}
          loading={UserStore.hasOutstandingRequests}
          options={!UserStore.hasOutstandingRequests ? UserStore.indexData : []}
          renderFunction={user => `${user.name} (${user.email})`}
          placeholder={this.props.placeholder}
          component={TextInput}
          border={null}
        />
      </div>
    );
  }
}

export default UserSearch;
